import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Flex, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import TxnStatus from "../../enums/TxnStatus";
import { useInterval } from "usehooks-ts";
import axios from "axios";
import { useStripe } from "@stripe/react-stripe-js";
var Stage;
(function (Stage) {
    Stage[Stage["STRIPE"] = 0] = "STRIPE";
    Stage[Stage["SUBTRUX"] = 1] = "SUBTRUX";
})(Stage || (Stage = {}));
const StripePaymentIntentStatusObserver = ({ paymentIntent, paymentIntentClientSecret, onPaymentSuccess, onPaymentFailure }) => {
    const stripe = useStripe();
    const [intentTxnStatus, setIntentTxnStatus] = useState(null);
    const [message, setMessage] = useState('Fetching payment details');
    const [fetching, setFetching] = useState(false);
    const [pollCount, setPollCount] = useState(0);
    const [pollingEnabled, setPollingEnabled] = useState(true);
    const [pollingStage, setPollingStage] = useState(Stage.STRIPE);
    useInterval(() => {
        setPollCount(pollCount + 1);
        if (pollCount > 15) {
            setPaymentFailed('Timeout.  Please try again later.');
        }
        if (pollingStage === Stage.STRIPE) {
            fetchStripeStatus();
        }
        else {
            fetchTxnStatus();
        }
    }, pollingEnabled ? 2000 : null);
    useEffect(() => {
        fetchStripeStatus();
    }, [stripe]);
    useEffect(() => {
        if (intentTxnStatus === TxnStatus.SUCCESS) {
            onPaymentSuccess();
        }
        else if (intentTxnStatus && intentTxnStatus != TxnStatus.PENDING) {
            setPaymentFailed("Payment " + intentTxnStatus.description);
        }
    }, [intentTxnStatus]);
    const setPaymentFailed = (errorMessage) => {
        setPollingEnabled(false);
        setPollCount(0);
        setMessage(errorMessage);
        onPaymentFailure();
    };
    const fetchStripeStatus = () => {
        if (fetching || !stripe || !paymentIntentClientSecret) {
            return;
        }
        setFetching(true);
        // Retrieve the PaymentIntent
        stripe
            .retrievePaymentIntent(paymentIntentClientSecret)
            .then((paymentIntentResult) => {
            // https://stripe.com/docs/payments/payment-methods#payment-notification
            switch (paymentIntentResult.paymentIntent?.status) {
                case 'succeeded':
                case 'requires_capture': //
                    setPollingEnabled(true);
                    setPollingStage(Stage.SUBTRUX);
                    setMessage('Waiting for payment acknowledgment...');
                    break;
                case 'processing':
                    setPollingEnabled(true);
                    setPollingStage(Stage.STRIPE);
                    setMessage("Contacting payment provider...");
                    break;
                case 'requires_payment_method':
                    setPaymentFailed('Payment failed. Please try another payment method.');
                    break;
                default:
                    setPaymentFailed('Something went wrong. Unknown status:' + paymentIntentResult.paymentIntent?.status);
                    break;
            }
        })
            .finally(() => setFetching(false));
    };
    const fetchTxnStatus = () => {
        if (fetching) {
            return;
        }
        setFetching(true);
        axios.get(`/admin/v1/stripe/payment-intents/${paymentIntent}/status`)
            .then((response) => {
            const status = TxnStatus.valueOf(response.data.status);
            setIntentTxnStatus(status ?? null);
            if (!status || status !== TxnStatus.PENDING) {
                setPollingEnabled(false);
            }
        })
            .catch(() => setPollingEnabled(false))
            .finally(() => setFetching(false));
    };
    return (_jsxs(Flex, { style: { minHeight: "100px", paddingTop: "20px" }, gap: "middle", align: "center", justify: "center", vertical: true, children: [pollingEnabled && _jsx(Spin, { indicator: _jsx(LoadingOutlined, { spin: true }), size: "large" }), _jsx("h3", { children: message })] }));
};
export default StripePaymentIntentStatusObserver;
